(function () {

seedWebApp.controller('DocTypeModalCtrl', DocTypeModal);

    function DocTypeModal(item, translation, isEdit, $uibModal, $uibModalInstance, DocService, ToastService) {
        var ctrl = this;

        ctrl.item = item;
        ctrl.translation = translation;
        ctrl.isEdit = isEdit;

        ctrl.addDoc = function () {
            DocService.saveDocType(ctrl.item).then(function (response) {
                successToast('O Tipo de Documento foi Adicionado.');
                $uibModalInstance.close();
            })
            .catch(function (error) {
                errorToast('Não Pode Haver ID Duplicado.');
            });
        }

        ctrl.updateDoc = function () {
            DocService.updateDocType(ctrl.item).then(function (response) {
                successToast('O Tipo de Documento foi Atualizado.');
                $uibModalInstance.close();
            })
            .catch(function (error) {
                errorToast('Erro ao Atualizar o Tipo de Documento.');
            });
        }

        ctrl.deleteDoc = function () {
            modalDeleteResult(openModalDelete());
        }

        ctrl.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };

        function openModalDelete() {
            return $uibModal.open({
                templateUrl: './SPA/Shared/delete-modal.html' + seedWebApp.buildVersion,
                controller: 'DeleteModalCtrl as ctrl',
                size: 'md',
                resolve: {
                    translation: function () {
                        return ctrl.translation;
                    },
                }
            });
        }

        function modalDeleteResult(modalInstance) {
            modalInstance.result.then(function (response) {
                if (response == 'true') confirmDeleteDoc();
            });
        }

        function confirmDeleteDoc() {
            DocService.deleteDocType(ctrl.item.DocTypeID).then(function (response) {
                successToast('O Tipo de Documento foi Removido.');
                $uibModalInstance.close();
            })
            .catch(function (error) {
                errorToast('Erro ao Remover o Tipo de Documento.');
            });
        }

        function successToast(msg) {
            ToastService.createToast(ctrl.translation.Success, msg, 8000, 'success');
        }

        function errorToast(error) {
            ToastService.createToast(ctrl.translation.Error, error, 5000, 'error');
        }
    }
})();